import type { TemplateWorkspace, Graph } from "@lr-notitia/notitia-operator/schemas";
import { Ref, computed } from "vue";
import { useSymbolsStore } from "../symbols";

let symbolsStore: ReturnType<typeof useSymbolsStore>;
function init() {
	symbolsStore = useSymbolsStore();
}

export const templateWorkspaces = (graph: Ref<Graph>) =>
	computed<TemplateWorkspace[]>(() => {
		if (!symbolsStore) init();
		return (
			Object.values(graph.value.nodes).filter(
				(node) => node.type === "workspace" && node.layer === "template"
			) as TemplateWorkspace[]
		).sort((a, b) =>
			symbolsStore
				.term({ id: a.refersTo, terminology: a.terminology })
				.toLocaleLowerCase()
				.localeCompare(symbolsStore.term({ id: b.refersTo, terminology: b.terminology }).toLocaleLowerCase())
		);
	});

export function templateWorkspace(domainId: Ref<string>, graph: Ref<Graph>) {
	return {
		byId: (id: string) => byId(id, graph),
	};
}

function byId(id: string, graph: Ref<Graph>): TemplateWorkspace | undefined {
	let hit = graph.value.nodes[id];
	return hit && hit.layer === "template" && hit.type === "workspace" ? (hit as TemplateWorkspace) : undefined;
}
